import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'accountingSystemImage'})
export class AccountingSystemImagePipe implements PipeTransform {
  transform(system: string, ...args: any[]): string {
    let imageUrl: string;

    switch (system) {
      case 'RZL':
        imageUrl = 'assets/img/accounting-systems/rzl.svg';
        break;
      case 'BMD':
        imageUrl = 'assets/img/accounting-systems/bmd.svg';
        break;
      case 'DATEV_SKR07':
        imageUrl = 'assets/img/accounting-systems/datev.svg';
        break;
      case 'RUNPLE_DEFAULT':
        imageUrl = 'assets/img/accounting-systems/runple.svg';
        break;
    }

    return imageUrl;
  }
}
